import React, {useState, useEffect} from "react";
import "./Learners.css";
import {
    englishUser,
    sinhalaUser,
    tamilUser,
} from "../../dummyData/LearnersData";
import {cities} from "../../dummyData/cities";
import {useNavigate} from "react-router-dom";
import DrivingSchoolCard from "../../Components/DrivingSchoolCard/DrivingSchoolCard";
import {useGetAllDrivingSchoolsMutation} from "../../redux/service/drivingSchoolService";
import {collection, getDocs} from "firebase/firestore";
import {db} from "../../firebase/firebase";

function Learners() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [drivingSchools, setDrivingSchools] = useState([]);
    const [language, setLanguage] = useState(sinhalaUser);
    const [selectedDistrict, setSelectedDistrict] = useState("");
    const [selectedCity, setSelectedCity] = useState("");
    const [cityList, setCityList] = useState([]);

    const [getAllDrivingSchools] = useGetAllDrivingSchoolsMutation();

    const handleCardClick = (learner) => {
        const learnerNameSlug = learner.name.toLowerCase().replace(/\s+/g, "-");
        navigate(`/drivingSchool/${learnerNameSlug}`);
    };

    useEffect(() => {
        // const fetchDrivingSchools = async () => {
        //   try {
        //     const response = await getAllDrivingSchools().unwrap();
        //     setDrivingSchools(response);
        //   } catch (error) {
        //     console.error("Failed to fetch driving schools:", error);
        //   }
        // };

        const fetchDrivingSchools = async () => {
            try {
                const querySnapshot = await getDocs(collection(db, "drivingSchools"));
                const schools = querySnapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                }));
                const permittedSchools = schools.filter(
                    (school) => school.permission === true
                );
                setDrivingSchools(permittedSchools);
                console.log("Fetched Driving Schools:", schools);
            } catch (error) {
                console.error("Failed to fetch driving schools:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchDrivingSchools();
        // console.log("Driving Schools:", drivingSchools);

        const selectedLanguageValue =
            localStorage.getItem("languageValue") || "sinhala";
        switch (selectedLanguageValue) {
            case "english":
                setLanguage(englishUser);
                break;
            case "tamil":
                setLanguage(tamilUser);
                break;
            default:
                setLanguage(sinhalaUser);
                break;
        }
    }, [getAllDrivingSchools]);

    useEffect(() => {
        const selectedCities = cities[selectedDistrict]?.cities || [];
        setCityList(selectedCities);
    }, [selectedDistrict]);

    const filteredSchools = drivingSchools.filter((school) => {
        if (!selectedDistrict && !selectedCity) return true;

        return school.branches.some((branch) => {
            const savedDistrict = branch.district.toLowerCase();
            const savedCity = branch.city?.toLowerCase();
            const district = selectedDistrict?.toLowerCase();
            const city = selectedCity?.toLowerCase();

            if (selectedDistrict && selectedCity) {
                return savedDistrict?.includes(district) && savedCity?.includes(city);
            }

            if (selectedDistrict && !selectedCity) {
                return savedDistrict?.includes(district);
            }

            if (!selectedDistrict && city) {
                return savedCity?.includes(city);
            }

            return false;
        });
    });

    return (
        <div>
            <div className="container-fluid pe-lg-5 pt-md-5">
                <div className="row justify-content-center align-items-start">
                    {/* Sidebar */}
                    <div
                        style={{
                            minHeight: "100vh",
                            backgroundColor: "#EEF2F6",
                            paddingLeft: 20,
                        }}
                        className="col-12 col-md-3 justify-content-start align-self-start d-flex flex-column"
                    >
                        <div className="flex-grow-1"></div>
                        <h3 className="fs-2 text-center">
                            Driving <span className="text-warning fw-bold">Schools</span>
                        </h3>
                        <br/>
                        <br/>
                        <div className="d-flex justify-content-start mb-3 fw-bold">
                            {language.searchTitle}
                        </div>
                        <div className="flex-grow-1">
                            <h6 className="pt-2 text-start">{language.district}</h6>
                            <select
                                className="form-select form-select-sm"
                                value={selectedDistrict}
                                onChange={(e) => setSelectedDistrict(e.target.value)}
                            >
                                <option value="" disabled selected>
                                    {language.selectDistrict}
                                </option>
                                {Object.keys(cities).map((district, index) => (
                                    <option key={index} value={district}>
                                        {district}
                                    </option>
                                ))}
                            </select>

                            <h6 className="pt-4 text-start">{language.nearestCity}</h6>
                            <select
                                className="form-select form-select-sm"
                                value={selectedCity}
                                onChange={(e) => setSelectedCity(e.target.value)}
                            >
                                <option value="" disabled selected>
                                    {language.selectCity}
                                </option>
                                {cityList.map((city, index) => (
                                    <option key={index} value={city}>
                                        {city}
                                    </option>
                                ))}
                            </select>
                        </div>
                        {/* <div className="flex-grow-1">
                            <h6 className="text-start">Services</h6>
                            {[
                                {id: "motorbike_license", label: "Motorbike License"},
                                {id: "three_wheel_license", label: "Three-wheel License"},
                                {id: "light_vehicle_license", label: "Light Vehicle License"},
                                {id: "heavy_vehicle_license", label: "Heavy Vehicle License"},
                            ].map((service) => (
                                <div
                                    className="form-check d-flex justify-content-start"
                                    key={service.id}
                                >
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        name={service.id}
                                        id={service.id}
                                        value={service.id}
                                    />
                                    <label className="form-check-label ms-2" htmlFor={service.id}>
                                        {service.label}
                                    </label>
                                </div>
                            ))}
                        </div> */}

                        <div className="flex-grow-1">
                            <h6 className="fw-bold mt-3">{language.freeTitle}</h6>

                            <a href="/new-learners-registation">
                                <button
                                    type="button"
                                    className="btn p-2 px-3 btn-register-custom"
                                >
                                    {language.regBtn}
                                </button>
                            </a>
                        </div>

                         {/* <div className="flex-grow-1">
                            <a href="/admin">
                                <button type="button" className="btn p-2 px-3 btn-danger">
                                    Loging
                                </button>
                            </a>
                        </div>  */}

                    </div>

                    {/* Main Content */}
                    <div className="col-12 col-md-9 justify-content-center align-self-start d-flex flex-column ps-3">
                        <div className="my-5"></div>
                        <div className="flex-grow-1">
                            {/* {LearnersData.map((learner, index) => (
                <div key={index} className="p-2 w-100">
                  <div onClick={() => handleCardClick(learner)}>
                    <DrivingSchoolCard
                      name={learner.name}
                      city={learner.city}
                      description={learner.description}
                      image={learner.image}
                    />
                  </div>
                </div>
              ))} */}

                            {filteredSchools ? (
                                filteredSchools.map((school, index) => (
                                    <div key={index} className="p-2 w-100">
                                        <div onClick={() => handleCardClick(school)}>
                                            <DrivingSchoolCard
                                                name={school?.name}
                                                city={school?.city}
                                                description={school?.description}
                                                image={school?.image}
                                            />
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <p>Driving Schools not found ...</p>
                            )}
                            <div className="d-flex justify-content-center">
                                {loading && (
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Learners;
